import React from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { isDesktop } from '../../../../utils/mobileHelpers';
import { VisitConsents } from '../VisitConsents';
import Popup from '../../../common/Popup';
import Paper from '../../../Paper';

function CompletedElectronicConsentPopup({
  item,
  opened,
  onClose,
  targetUser,
  formatMessage,
}) {
  const dateTime = get(item, 'completedTime');

  const consentItem = {
    service: {},
    patientUserInfo: targetUser,
    dateTime,
    consentsAssignment: {
      allSigned: true,
      consents: [item.consent],
      consentsCount: 1,
      id: item.id,
    },
  };

  return (
    <Popup
      strictClose
      opened={opened}
      onClose={onClose}
      title={formatMessage({ id: 'appointments.form.consentForm' })}
      width={isDesktop() ? 'small' : 'medium'}
    >
      <Paper isLayoutColumn className="pa3">
        <VisitConsents
          appointment={consentItem}
          formatMessage={formatMessage}
        />
      </Paper>
    </Popup>
  );
}

CompletedElectronicConsentPopup.propTypes = {
  formatMessage: PropTypes.func,
  opened: PropTypes.bool,
  item: PropTypes.object,
  onClose: PropTypes.func,
  targetUser: PropTypes.object,
};

export default CompletedElectronicConsentPopup;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/CompletedElectronicConsentPopup/index.jsx